import { ValidationErrorResponse } from "../../../services/ValidationError";
import { hoy } from "../../../utils/dateUtils";

export interface FormValue {
    wasTouched: boolean,
    isValid: boolean | undefined
}

export interface TextFormValue extends FormValue {
    value: string
}

export interface FileFormValue extends FormValue {
    value: File | undefined
}

export interface BooleanFormValue extends FormValue {
    value: boolean
}

export interface FormState {
    nombresPropietario: TextFormValue,
    nombre: TextFormValue,
    foto: FileFormValue,
    certificadoVacuna: FileFormValue,
    fechaIngreso: TextFormValue,
    raza: TextFormValue,
    sexo: TextFormValue,
    fechaNacimiento: TextFormValue,
    comentarios: TextFormValue,
    estaEsterilizada: BooleanFormValue,
    tieneCondicionMedica: BooleanFormValue,
    observacionesMedicas: TextFormValue,
    nombreVeterinario: TextFormValue,
    temperamento: TextFormValue,
    observacionesTemperamento: TextFormValue,
    observacionesAlimenticias: TextFormValue,
    fechaGarrapaticida: TextFormValue,
    mesesPeriodicidadGarrapaticida: TextFormValue,
    fechaVacuna: TextFormValue,
    eliminarFoto: BooleanFormValue,
    eliminarCertificadoVacuna: BooleanFormValue
}

export const initialFormState: FormState = {
    nombresPropietario: { value: "", wasTouched: false, isValid: undefined },
    nombre: { value: "", wasTouched: false, isValid: undefined },
    foto: { value: undefined, wasTouched: false, isValid: undefined },
    certificadoVacuna: { value: undefined, wasTouched: false, isValid: undefined },
    fechaIngreso: { value: hoy(), wasTouched: false, isValid: undefined },
    raza: { value: "", wasTouched: false, isValid: undefined },
    sexo: { value: "", wasTouched: false, isValid: undefined },
    fechaNacimiento: { value: "", wasTouched: false, isValid: undefined },
    comentarios: { value: "", wasTouched: false, isValid: undefined },
    estaEsterilizada: { value: false, wasTouched: false, isValid: undefined },
    tieneCondicionMedica: { value: false, wasTouched: false, isValid: undefined },
    observacionesMedicas: { value: "", wasTouched: false, isValid: undefined },
    nombreVeterinario: { value: "", wasTouched: false, isValid: undefined },
    temperamento: { value: "", wasTouched: false, isValid: undefined },
    observacionesTemperamento: { value: "", wasTouched: false, isValid: undefined },
    observacionesAlimenticias: { value: "", wasTouched: false, isValid: undefined },
    fechaGarrapaticida: { value: "", wasTouched: false, isValid: undefined },
    mesesPeriodicidadGarrapaticida: { value: "", wasTouched: false, isValid: undefined },
    fechaVacuna: { value: "", wasTouched: false, isValid: undefined },
    eliminarFoto: { value: false, wasTouched: false, isValid: undefined },
    eliminarCertificadoVacuna: { value: false, wasTouched: false, isValid: undefined }
}

export const resetValidStates = (formState: FormState) => {
    Object.keys(formState).forEach(_key => {
        const currentVal: FormValue = (formState as any)[_key] as FormValue;
        (formState as any)[_key] = { ...currentVal, isValid: undefined };
    });
}

export const invalidateStates = (formState: FormState, validationErrorResponse: ValidationErrorResponse) => {
    Object.keys(validationErrorResponse).forEach(errKey => {
        const errKeyStr = errKey as string;
        const currentVal: FormValue = (formState as any)[errKeyStr] as FormValue;
        (formState as any)[errKeyStr] = { ...currentVal, isValid: false };
    })
}